import { render } from "./ContentFooter.vue?vue&type=template&id=52e56508"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"

import "./ContentFooter.vue?vue&type=style&index=0&id=52e56508&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layout/ContentFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52e56508"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52e56508', __exports__)) {
    api.reload('52e56508', __exports__)
  }
  
  module.hot.accept("./ContentFooter.vue?vue&type=template&id=52e56508", () => {
    api.rerender('52e56508', render)
  })

}


export default __exports__